<template>
    <div>
        <v-autocomplete
            v-bind:label="'Select '+filter"
            v-model="input"
            :items="this.items"
        ></v-autocomplete>
    </div>
</template>

<script>
export default {
    name: "MoleculeSelector",
    props: {
        molecules: Array,
        filter: String
    },
    data:
        function() {
            return {
                input: null
            }
        },
    computed: {
        items() {
            return this.getItems(this.filter);
        }
    },
    methods: {
        getItems(filter) {
            let items = [];
            switch(filter) {
                case 'name':
                    items = this.getNames();
                    break;
                case 'formula':
                    items = this.getFormulas();
                    break;
                case 'SMILES':
                    items = this.getSmiles();
                    break;
                case 'InChI':
                    items = this.getInchis();
                    break;
            }
            return items;
        },
        getSmiles() {
            return this.molecules.map(molecule => molecule["smiles"]);
        },
        getInchis() {
            return this.molecules.map(molecule => molecule["inchi"]);
        },
        getNames() {
            let names = [];
            this.molecules.forEach((molecule) => {
                molecule.primaryName ? names.push(molecule.primaryName) : "";
                molecule.aliases.forEach((alias) => {
                names.push(alias.alias);
                });
            });
            // make names list unique (done automatically by combobx ?!)
            // sort names by alphabetics order
            names.sort();
            return names;
        },
        getFormulas() {
            let formulas = [];
            this.molecules.forEach((molecule) => {
                molecule['molecularFormula'] ? formulas.push(molecule['molecularFormula']) : "";
                molecule['formulas'].forEach((formula) => {
                formulas.push(formula['formula']);
                });
            });
            // make names list unique (done automatically by combobx ?!)
            // sort names by alphabetics order
            formulas.sort();
            return formulas;
        },
        findBy(filter, input) {
            let molecules = [];
            switch(filter) {
                case 'name':
                    molecules = this.findByName(input);
                    break;
                case 'formula':
                    molecules = this.findByFormula(input);
                    break;
                case 'SMILES':
                    molecules = this.findBySmiles(input);
                    break;
                case 'InChI':
                    molecules = this.findByInchi(input);
                    break;
            }
            return molecules;
        },
        findBySmiles(input) {
            return this.molecules.filter(molecule => molecule['smiles']==input);
        },
        findByInchi(input) {
            return this.molecules.filter(molecule => molecule['inchi']==input);
        },
        findByName(input) {
            return this.molecules.filter(molecule => molecule['primaryName']==input || molecule['aliases'].map(alias => alias['alias']).includes(input));
        },
        findByFormula(input) {
            return this.molecules.filter(molecule => molecule['molecularFormula']==input || molecule['formulas'].map(alias => alias['formula']).includes(input));
        },
        find() {
            this.$emit('get-molecules', this.findBy(this.filter, this.input));
        }
    }
}
</script>